import type { components } from "@/lib/api/generated/schema";

/** Kênh khách xác nhận đã nhận đủ ảnh khi nhân viên bấm hộ — gương của
 *  `validAcceptChannels` bên Go và của rào CHECK `accept_channel` ở CSDL. Kiểu
 *  lấy từ hợp đồng nên gõ sai mã là lỗi lúc build. */
export type AcceptChannel = components["schemas"]["CskhAcceptOnBehalfInput"]["channel"];

export const ACCEPT_CHANNELS = [
  { value: "call", label: "Gọi điện" },
  { value: "zalo", label: "Zalo" },
  { value: "sms", label: "Nhắn tin" },
  { value: "in_person", label: "Gặp trực tiếp" },
] as const satisfies readonly { value: AcceptChannel; label: string }[];

// Hợp đồng thêm kênh mới mà bảng trên chưa có thì build đỏ ở đây — thiếu một
// ô chọn là người bấm hộ không có cách nào khai đúng kênh khách đã dùng.
type MissingChannel = Exclude<AcceptChannel, (typeof ACCEPT_CHANNELS)[number]["value"]>;
const everyChannelHasLabel: [MissingChannel] extends [never] ? true : false = true;
void everyChannelHasLabel;

/** Nhãn tiếng Việt của kênh. Mã lạ (dữ liệu cũ) trả nguyên mã thay vì bịa nhãn. */
export function acceptChannelLabel(channel: string): string {
  return ACCEPT_CHANNELS.find((c) => c.value === channel)?.label ?? channel;
}
